import fetch from "auth/FetchInterceptor";

const JwtAuthService = {};

JwtAuthService.login = function (data) {
  return fetch({
    url: "/authenticate/login",
    method: "post",
    data: data,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  });
};

JwtAuthService.signUp = function (data) {
  return fetch({
    url: "/auth/signup",
    method: "post",
    data: data,
  });
};

JwtAuthService.permissions = function () {
  return fetch({
    url: "/profile/permissions",
    method: "get",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  });
};

export default JwtAuthService;
